import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/* eslint-disable no-constant-condition */

/**
 * A redux middleware which adds support for async actions and action
 * sequences.
 */
var reduxMiddleware = function reduxMiddleware(_ref) {
  var dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      if (isIterator(action)) {
        if (supportsAsyncIteration(action)) {
          return consumeAsyncIterator(dispatch, action);
        } // Yes, this is phrased oddly. TypeScript insisted.


        if (!supportsAsyncIteration(action)) {
          return consumeSyncIterator(dispatch, action);
        }
      }

      return next(action);
    };
  };
}; // This produces the set of all things which can be dispatched.


// Consume the async iterator. Every yielded value is dispatched and the
// return value is resolved and returned from `dispatch(...)`.
var consumeAsyncIterator = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, iterator) {
    var prevDispatchResult, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!true) {
              _context.next = 11;
              break;
            }

            _context.next = 3;
            return iterator.next(prevDispatchResult);

          case 3:
            result = _context.sent;

            if (!result.done) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", result.value);

          case 6:
            _context.next = 8;
            return dispatch(result.value);

          case 8:
            prevDispatchResult = _context.sent;
            _context.next = 0;
            break;

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function consumeAsyncIterator(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();

var consumeSyncIterator = function consumeSyncIterator(dispatch, iterator) {
  var prevDispatchResult;

  while (true) {
    var result = iterator.next(prevDispatchResult);
    if (result.done) return result.value;
    prevDispatchResult = dispatch(result.value);
  }
};

var supportsAsyncIteration = function supportsAsyncIteration(iterator) {
  return Symbol.asyncIterator in iterator;
};

var isIterator = function isIterator(value) {
  return value && typeof value.next === 'function' && typeof value["throw"] === 'function' && typeof value["return"] === 'function';
}; // Pull the return type out of an async iterator.


export default reduxMiddleware;